import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { ComisionesLayOut } from 'src/app/model/commission-layout/comisiones-layout';

@Injectable({
  providedIn: 'root'
})
export class CommissionLayoutService {

  private useDummy = false; // Cambiar a 'true' para usar la versión dummy del envio de correos
  
  private url:string;
  
  constructor(private http:HttpClient) {
    this.url=environment.services_url;
  }

  saveCommissionsLayout(comisionesLayOut: ComisionesLayOut) {
    return this.http.post(`${this.url}/nomina/comisionLayOut/saveLayOut`, comisionesLayOut);
  }

  sendEmailComisionesLayOutCarga(formData: FormData) {
    if (this.useDummy) {
      // Versión dummy
      return of({ 
        status: 'OK', 
        message: 'Email enviado correctamente (DUMMY)',
        timestamp: new Date().toISOString()
      }).pipe(delay(2000));
    } else {
      // Versión real
      return this.http.post(`${this.url}/nomina/comisionLayOut/sendEmail/carga`, formData);
    }
  }
  
  getAllDocuments() {
    return this.http.get(`${this.url}/nomina/comisionLayOut/allDocuments`);
  }

  getDocumentById(id: string) {
    return this.http.get(`${this.url}/nomina/comisionLayOut/document/${id}`);
  }

  getDocumentCargasByLayOutId(id: string) {
    return this.http.get(`${this.url}/nomina/comisionLayOut/document/cargas/${id}`);
  }

  getDocumentEnviosByLayOutId(id: string) {
    return this.http.get(`${this.url}/nomina/comisionLayOut/document/envios/${id}`);
  }

  sendCommissionLayOut(comisionesLayOut: ComisionesLayOut) {
    return this.http.post(`${this.url}/nomina/comisionLayOut/send`, comisionesLayOut);
  }

  sendEmailComisionesLayOutEnvio(formData: FormData) {
    if (this.useDummy) {
      // Versión dummy
      return of({ 
        status: 'OK', 
        message: 'Email enviado correctamente (DUMMY)',
        timestamp: new Date().toISOString()
      }).pipe(delay(2000));
    } else {
      // Versión real
      return this.http.post(`${this.url}/nomina/comisionLayOut/sendEmail/envio`, formData);
    }
  }

  analyzeLayOutForDuplicates(comisionesLayOut: ComisionesLayOut) {
    return this.http.post(`${this.url}/nomina/comisionLayOut/analyzeDuplicates`, comisionesLayOut);
  }
    
}
